/* eslint-disable no-restricted-globals */
/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2022. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import { URL_MATCHER } from '@/constants';

export default {
  methods: {
    getNotificationBackgroundURL(path, isShowBeforeLogin) {
      if (isShowBeforeLogin) {
        return `${location.protocol}//${
          location.hostname
        }/nerve_notification/storage/background_images_public${path}?${new Date().getTime()}`;
      }
      return `${location.protocol}//${
        location.hostname
      }/nerve_notification/storage/background_images${path}?${new Date().getTime()}`;
    },
    async showNotification() {
      await this.$store.dispatch('notifications/getActiveNotificationAfterLogin');
      if (this.getActiveNotification.active && !this.getActiveNotification.showBeforeLogin) {
        if (this.getActiveNotification.backgroundImage) {
          this.getActiveNotification.backgroundImage = await this.$store.dispatch('notifications/getImage');
        }
        const textMessageWithLinks = this.getActiveNotification.textMessage.replace(
          URL_MATCHER,
          '<a href="$1" target="_blank">$1</a>',
        );
        await this.$store.dispatch('utils/_api_request_handler/show_notification_dialog', {
          title: this.getActiveNotification.headerText,
          subTitle: this.getActiveNotification.textMessage,
          backgroundImage: this.getActiveNotification.backgroundImage,
          textMessageWithLinks,
        });
      }
    },
  },
};
